import { Link } from 'react-router-dom';

const PRODUCT_IMAGE = '/checkout-product.jpg';

export default function CheckoutSection() {
  return (
    <section className="bg-[#FDFAF8] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Eyebrow */}
        <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4 text-center">
          Ready to begin?
        </p>

        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#1A1A1A] text-center mb-14 leading-tight">
            Your set is waiting.
        </h2>

        {/* Product Card */}
        <div className="max-w-3xl mx-auto bg-[#FDFAF8] border border-[#C9A84C]/30 rounded-lg overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2">
            {/* Product Image */}
            <div className="aspect-square md:aspect-auto bg-[#FDFAF8]">
              <img
                src={PRODUCT_IMAGE}
                alt="The H.O.M.E Collection, Journal + Card Deck Set"
                className="w-full h-full object-contain object-center"
                title="The H.O.M.E Collection"
              />
            </div>

            {/* Product Details */}
            <div className="p-6 md:p-10 flex flex-col justify-center">
              <h3 className="font-heading text-xl md:text-2xl text-[#1A1A1A] mb-2">
                The H.O.M.E Collection
              </h3>
              <p className="font-body text-sm text-[#5A5A5A] mb-4">
                Journal + Card Deck Set
              </p>
              <p className="font-body text-xs text-[#6B6B6B] mb-6">
                Physical printed set, shipped to you
              </p>

              {/* Price */}
              <p className="font-heading text-2xl text-[#1A1A1A] mb-6">
                 40,000
              </p>

              {/* CTA Button */}
              <a
                href="https://paystack.com/buy/the-home-collection-ktdhov"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full inline-flex items-center justify-center px-8 py-4 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300 mb-4 text-center whitespace-nowrap"
              >
                Buy Now — Get The Collection
              </a>

              {/* Trust signals */}
              <div className="flex items-center gap-4 text-xs font-body text-[#6B6B6B]">
                <div className="flex items-center gap-1">
                  <i className="ri-shield-check-line text-[#C9A84C]" />
                  <span>SSL Encrypted</span>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-secure-payment-line text-[#C9A84C]" />
                  <span>Paystack</span>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-arrow-go-back-line text-[#C9A84C]" />
                  <span>14-Day Returns</span>
                </div>
              </div>

              {/* Gift message */}
              <p className="font-body text-xs text-[#6B6B6B] mt-4">
                Add a personalised gift message at checkout
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}